<template>
  <div class="">
    <b-card v-if="usersLoading">
      {{ $t('generic.loading', 'Loading') }}...
    </b-card>
    <b-card v-if="usersList.fetchListError">
      {{ $t('pages.admin.users.something-wrong') }}
    </b-card>
    <b-card v-if="!usersLoading && !usersList.fetchListError">
      <div class="text-left mb-2">
        <span style="font-size: 0.8rem;">{{ $t('pages.admin.users.total-label', 'Total users:') }}</span> {{ paginationMeta ? paginationMeta.total : "" }}
      </div>
      <div
        id="filtersContainer"
        class="d-flex flex-row justify-content-between"
      >
        <b-input
          v-model="filter.fields.keyword"
          class="flex-grow-1 native"
          size="sm"
          :placeholder="$t('inputs.keyword.placeholder', 'Keywords')"
        />

        <b-form-select
          v-model="filter.order"
          size="sm"
          :options="orderByOptions"
        />

        <b-form-select
          v-model="filter.fields.type"
          size="sm"
          :options="filterByOptions"
          :disabled="isHr"
        />
        <b-form-checkbox
          v-model="filter.fields.activeOnly"
          class="m-auto activeOnlyCheckbox"
        >
          {{ $t('pages.admin.users.only-active', 'Only active') }}
        </b-form-checkbox>
      </div>
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        @pagination-change-page="getResults"
      />
      <UserCard
        v-for="user in usersList"
        :key="user.id"
        :user="user"
        @delegateModalToggle="delegateModalToggle"
      />
      <pagination
        v-if="paginationMeta"
        :data="paginationMeta"
        size="small"
        :limit="1"
        align="center"
        @pagination-change-page="getResults"
      />
      <div v-if="!usersList.length">
        {{ $t('pages.admin.users.no-users', 'No users found...') }}
      </div>
    </b-card>
    <!-- Delete user modal -->
    <b-modal
      v-model="destroyModal"
      title="Are you sure you want to delete?"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      size="md"
      @ok="destroyModal = false; destroy(selectedUser)"
    >
      {{ $t('pages.admin.users.no-recover') }}
    </b-modal>
    <b-modal
      v-model="registerModal"
      title="Create a new User"
      header-bg-variant="danger"
      header-text-variant="light"
      centered
      size="md"
      @ok="destroyModal = false;"
    >
      <Register
        :is-admin="true"
        @closeModal="userAdded"
      />
    </b-modal>
    <!--  -->

    <!-- Delegate User Modal (HR) -->
    <b-modal
      v-model="delegateModalShow"
      centered
      header-bg-variant="warning"
      @ok="delegateToOffer"
    >
      {{ $t('pages.admin.users.confirm-delegate') }}
    </b-modal>
    <!--  -->
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

import Register from '@/views/auth/Register';
import UserCard from "@/components/jobs/admin/UserCard";

export default {
  components: {
    UserCard,
    Register
  },
  props: {
    isHr: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      destroyModal: false, //Modal for delete
      selectedUser: '', //We put user for deletion here
      registerModal: false, //Modal for add new user,
      paginationMeta: null,

      filter: {
        fields: {
          keyword: '',
          type: '',
          activeOnly: true
        },
        order: '',
        watchersEnabled: false,
      },
      page: 1,

      debounces: {},

      delegateModalShow: false,
      delegateSelectedUserId: null
    }
  },
  computed: {
    ...mapGetters('users', {
      usersLoading: 'isLoading',
      usersList: 'list'
    }),

    ...mapState([
      'route', // vuex-router-sync
    ]),

    orderByOptions() {
      return [
        {
          label: this.$t('pages.admin.users.filter-options.order.label', 'Order by...'),
          options: [
            { value: '', text: this.$t('pages.admin.users.filter-options.order.newest', 'Sort newest first') },
            { value: 'name', text: this.$t('pages.admin.users.filter-options.order.name', 'Sort alphabetically') },
            { value: 'email', text: this.$t('pages.admin.users.filter-options.order.email', 'Sort by email') },
          ]
        }
      ];
    },

    filterByOptions() {
        return [
          {
            label: this.$t('pages.admin.users.filter-options.filter.label', 'Filter users'),
            options: [
              { value: '', text: this.$t('pages.admin.users.filter-options.filter.all-users', 'All users') },
              { value: 'companies', text: this.$t('pages.admin.users.filter-options.filter.companies', 'Only companies') },
              { value: 'candidates', text: this.$t('pages.admin.users.filter-options.filter.candidates', 'Only candidates') },
              { value: 'hrs', text: this.$t('pages.admin.users.filter-options.filter.hrs', 'Only HRs') },
              { value: 'withcv', text: this.$t('pages.admin.users.filter-options.filter.withcv', 'Only candidates with CV') },
            ]
          }
        ]
    }
  },

  watch: {
    'filter.fields': {
      handler() {
        if (!this.filter.watchersEnabled) return;

        this.debounceCallback('filterUpdate', 750, () => {
          this.fetchData(1);
        });
      },

      deep: true,
    },

    'filter.order'() {
      if (!this.filter.watchersEnabled) return;

      this.debounceCallback('filterUpdate', 750, () => {
        this.fetchData(this.page);
      });
    }
  },

  created() {
    // CHECK FOR PERMISSIONS
    if(!this.$can('users_manage') && !this.$hasRole(['super-admin']) && !this.$hasRole(['hr'])) {
      this.$router.push({ name: 'not-found' });
      return;
    }
    this.filter.fields = {
      keyword: this.$route.query.keyword,
      type: this.$route.query.type || '',
      activeOnly: this.$route.query.activeOnly || ''
    };
    this.filter.order = this.$route.query.order || '';
    setTimeout(() => {
      this.filter.watchersEnabled = true;
    }, 10);

    // Adjust to show Headhunters only
    if(this.isHr) {
      this.filter.fields.type = "hrs";
    }

    this.fetchData(this.$route.query.page || 1);
  },
  methods: {
    ...mapActions('users', {
      fetchUsers: 'fetchList',
      destroyUser: 'destroy'
    }),

    fetchData(page) {
      this.page = page;
      this.$router.replace({ query: { ...this.filter.fields, order: this.filter.order, page }});

      return this.fetchUsers({
        config: {
          params: {
            ...this.filter.fields,
            order: this.filter.order,
            page,
            delegate: this.$route.params.id // If route == delegate
          }
        }
      })
        .then((response) => { this.paginationMeta = response.meta })
        .catch(() => {
          this.$toastSomethingWentWrong();
        });
    },
    editUser(user) {
      this.$router.push({ name: 'admin-user', params: { id: user.id } });
    },
    destroy(user) {
      this.destroyUser({ id: user.id })
        .then( () => {
          this.$toastNotification('success', '', this.$t('pages.admin.users.deleted-success'));
        })
        .catch( (error) => {
          this.$toastNotification('danger', '', error.response.data.error);
        })
    },

    userAdded() {
      this.registerModal = false;
      this.fetchData();
      this.$toastNotification('success', '', 'Created successfully');
    },

    getResults(page){
      return this.fetchData(page)
        .then(() => { window.scrollTo(0, 0) });
    },

    debounceCallback(key, duration, callback) {
      if (this.debounces[key]) {
        clearTimeout(this.debounces[key]);
      }

      this.debounces[key] = setTimeout(callback, duration);
    },

    // HR Delegate
    delegateModalToggle(userId) {
      this.delegateModalShow = !this.delegateModalShow;
      this.delegateSelectedUserId = userId;
    },

    delegateToOffer() {
      let data = {
        userId: this.delegateSelectedUserId,
        offerId: this.$route.params.id
      }
      this.axios.post('/delegate/user', data)
        .then( () => {
          this.fetchData(this.page);
          this.$toastNotification('success', '', this.$t('pages.admin.users.delegate-success'));
        })
        .catch( () => {
          this.$toastSomethingWentWrong();
        });
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    background: #f2f2f2;
  }
  #filtersContainer {
    * {
      margin: 5px;
    }

    button {
      min-width: 120px;
    }

    select {
      max-width: 200px;
    }
  }

  .activeOnlyCheckbox {
    font-size: 0.9rem;
    line-height: 0.9rem;
  }
</style>
